export default {
  root: ({ props, instance }) => ({
    class: [
      'w-full',
      { 'flex gap-x-3': !props.multiple && !instance.$attrs['bulk-upload'] },
      { 'text-center': instance.$attrs['bulk-upload'] },
    ],
  }),
  input: {
    class: 'hidden',
  },
  buttonbar: ({ props }) => ({
    class: [
      // Colors
      'bg-surface-50',
      'text-surface-700',

      // Shape
      'rounded-tr-lg',
      'rounded-tl-lg',

      // Position
      { 'flex justify-between items-center pb-4': props.multiple },
    ],
  }),
  chooseButton: {
    class: [
      'relative',

      // Alignments
      'items-center inline-flex text-center align-bottom justify-center',

      // Spacing
      'px-4 py-3',

      // Shape
      'rounded-md',

      // Font
      'leading-[normal]',
      'font-bold',

      // Colors
      'text-white',
      'bg-primary-500',
      'border-primary-500',

      // States
      'hover:bg-primary-600',

      // Misc
      'overflow-hidden',
      'cursor-pointer',
    ],
  },
  chooseIcon: {
    class: ['mr-2', 'inline-block'],
  },
  chooseButtonLabel: {
    class: ['flex-1', 'font-bold'],
  },
  uploadbutton: {
    icon: {
      class: 'mr-2',
    },
  },
  cancelbutton: {
    icon: {
      class: 'mr-2',
    },
  },
  content: {
    class: [
      // Position
      'relative',

      // Colors
      'bg-transparent',
      'text-surface-700',

      // Shape
      'rounded-b-lg w-full',
    ],
  },
  file: {
    class: [
      // Flexbox
      'flex',
      'items-center',
      'flex-wrap',

      // Spacing
      'p-4',
      'mb-2',
      'last:mb-0',

      // Borders
      'border',
      'border-surface-200',
      'gap-2',

      // Shape
      'rounded',
    ],
  },
  thumbnail: {
    class: 'shrink-0',
  },
  fileName: {
    class: 'mb-2',
  },
  fileSize: {
    class: 'mr-2',
  },
  uploadicon: {
    class: 'mr-2',
  },
  progressbar: {
    root: {
      class: [
        // Position and Overflow
        'overflow-hidden',
        'absolute top-0 left-0',

        // Shape and Size
        'border-0',
        'h-2',
        'rounded-md',
        'w-full',

        // Colors
        'bg-surface-100',
      ],
    },
    value: {
      class: [
        // Flexbox & Overflow & Position
        'absolute flex items-center justify-center overflow-hidden',

        // Colors
        'bg-primary-500',

        // Spacing & Sizing
        'm-0',
        'h-full w-0',

        // Shape
        'border-0',

        // Transitions
        'transition-width duration-1000 ease-in-out',
      ],
    },
  },
};
